import MultiselectField from './multiselect'

export default MultiselectField


// WEBPACK FOOTER //
// ./src/registration-forms-editor/components/fields/multiselect/index.js